import { render, staticRenderFns } from "./eightEcharts.vue?vue&type=template&id=3c36c12e&"
import script from "./eightEcharts.vue?vue&type=script&lang=js&"
export * from "./eightEcharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports